










































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import {Location} from "vue-router"
import JdhSneakPeek from "@/design-system/shared/JdhSneakPeek.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 5.1.1 Add disabled mode and hint.
 */
@Component({
    components: { JdhSneakPeek }
})
export default class JdsNavigatorChildItem extends Vue {
    showDisabledTooltip = false;

    @Ref() anchorEl!: HTMLElement

    @Prop({default: false, type: Boolean}) last!: boolean;
    @Prop() to!: Location;

    /**
     * Passed into the router-link as the `exact` prop.
     */
    @Prop({type: Boolean, default: false}) exact!: boolean;

    @Prop({type: Boolean, default: false}) disabled!: boolean;
}
